import { render, staticRenderFns } from "./DiagSectionMasterDeleteList.vue?vue&type=template&id=04b1e1c6&"
import script from "./DiagSectionMasterDeleteList.vue?vue&type=script&lang=js&"
export * from "./DiagSectionMasterDeleteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports